import React, { Component, Fragment } from "react";
import { getWhseList } from "../../actions";

class DcSelector extends Component {
  state = { dropdownList: "closed", label: "Select Warehouse", jsonObj: [] };
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.singleSelectRef = React.createRef();
    this.lookup = false;
    this.selectedWhses = [];
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    // Use preloaded warehouse list if available
    if (
      nextProps.preloadedWarehouseList &&
      nextProps.preloadedWarehouseList.length > 0 &&
      prevState.jsonObj.length === 0
    ) {
      return {
        jsonObj: nextProps.preloadedWarehouseList
      };
    }

    if (
      nextProps.whsesForItem &&
      nextProps.whsesForItem !== prevState.jsonObj
    ) {
      return {
        jsonObj: nextProps.whsesForItem
      };
    } else {
      return null;
    }
  }
  componentDidUpdate() {}
  componentDidMount() {
    // Only load warehouse list if not preloaded
    if (!this.props.preloadedWarehouseList || this.props.preloadedWarehouseList.length === 0) {
      getWhseList().then(res => {
        if (res && res.data && res.data.whses) {
          this.setState({ jsonObj: res.data.whses });
        }
      }).catch(err => {
        // Silently fail if no session - component will work with empty warehouse list
        console.warn('Could not load warehouse list:', err);
      });
    }
  }
  onChange = (property, value) => {
    if (this.selectedWhses.length === 1 && !value) {
      value = true;
      this.props.setErrorMsg("Must Have One Valid Warehouse");
    } else {
      this.lookup = true;
      this.setState({ [property]: value });
      var index;
      if (value) {
        if (!this.selectedWhses[this.selectedWhses.indexOf(property)]) {
          this.selectedWhses.push(property);
        }
      } else {
        index = this.selectedWhses.indexOf(property);
        this.selectedWhses.splice(index, 1);
      }
      setTimeout(() => {
        this.props.onChangeHandler(this.selectedWhses);
      }, 30);
    }
  };
  renderSelectedDCs = () => {
    // this is the list of selected DC's, not the dropdown list of selectable
    return this.selectedWhses.map((selectedDC, key) => {
      // will render new DC's in state
      return (
        <label htmlFor={selectedDC} key={key} className="selected-dc-box">
          {selectedDC}
        </label>
      );
    });
  };

  renderDCs = (param, intlCode) => {
    // now these are the DCs at the dropdown list
    if (this.state.jsonObj) {
      return this.state.jsonObj.map((DC, key) => {
        if (param === "updatelist" && !DC.isDisabled) {
          this.setState({ [DC.whse]: DC.isChecked });
        } else {
          if (intlCode === DC.whseCountry) {
            if(DC.whse == "69") DC.whseName = "CUSTOM GOODS";
            return (
              <li key={key} className="custom-option">
                <label htmlFor={DC.whse}>
                  {DC.whse} - {DC.whseName}
                </label>
                <input
                  className="listed-dc"
                  type="checkbox"
                  id={DC.whse}
                  onClick={e => this.renderSelectedDCs()} // this will update selected DCs list
                  onChange={e => this.onChange(DC.whse, e.target.checked)}
                  disabled={DC.isDisabled} // this will prevent user from checking/unchecking DCs that are locked
                  checked={!DC.isDisabled ? this.state[DC.whse] : DC.isChecked} // this will controll the input
                />
              </li>
            );
          }
        }
        return null;
      });
    }
  };

  checkAllToggle = (e, param) => {
    this.closeDropDown();
    for (let i = 0; i < this.state.jsonObj.length; i++) {
      if (this.state.jsonObj[i].whseCountry === param || (param == 'USA' && this.state.jsonObj[i].whseCountry == 'STORESUP')) {
        this.onChange(this.state.jsonObj[i].whse, e.target.checked);
      }
    }
    this.setState({ [param]: e.target.checked });
    this.renderSelectedDCs();
  };
  closeDropDown() {
    this.setState({ dropdownList: "closed" });
    this.inputRef.current.checked = false;
  }
  onchangeSingleWhse = value => {
    var count = 0;
    const obj = {};
    const whses = this.state.jsonObj;
    for (let i = 0; i < whses.length; i++) {
      if (value === whses[i].whse) {
        this.setState({ label: whses[i].whseName });
        count++;
      }
    }
    if (count === 0) {
      this.setState({ label: "Please select a valid Whse" });
    }
    this.props.onChangeHandler(value);
  };
  renderSingleSelectOptions = country => {
    return this.state.jsonObj.map(wse => {
      if (wse.whseCountry === country) {
        return (
          <Fragment>
            <option value={wse.whse}>
              {wse.whse} - {wse.whseName}
            </option>
          </Fragment>
        );
      }
    });
  };

  openOnFocus = () => {
    this.setState({ dropdownList: "open" });
    this.inputRef.current.checked = true;
  };
  focusSingleDpdwn = e => {
    e.keypress = "enter";
  };

  render() {
    return (
      <div className="select-dcs">
        {this.props.singleSelect ? (
          <div className="single-whse-selector">
            <select
              ref={this.singleSelectRef}
              name="whseSingleSelect"
              onChange={e => this.onchangeSingleWhse(e.target.value)}
              id="whseSingleSelect"
              style={{
                overflow: "hidden",
                width: "45px",
                border: "none"
              }}
              onFocus={e => this.focusSingleDpdwn(e)}
            >
              <option disabled selected value="" style={{ display: "none" }} />
              <optgroup label="USA">
                {this.renderSingleSelectOptions("USA")}
              </optgroup>
              <optgroup label="MEX">
                {this.renderSingleSelectOptions("MEX")}
              </optgroup>
            </select>
            {/* <input
              className="single-whse-selector-custom-input"
              onChange={e => this.onchangeSingleWhse(e.target.value)}
            /> */}
            <label htmlFor="whseSingleSelect" className={"DCSelector-label"}>
              {this.state.label}
            </label>
          </div>
        ) : (
          <Fragment>
            <input
              style={{ width: "15px", position: "absolute", opacity: 0 }}
              onFocus={e => this.openOnFocus()}
            />
            {this.state.dropdownList === "open" ? (
              <div className="close-area" onClick={e => this.closeDropDown()} />
            ) : null}
            <div className="custom-selector">
              {/* <div id="counter" /> */}
              <label>
                <div className="input-area">
                  {this.renderSelectedDCs()}
                  {/* it will fire the renderDCs method at interacting whit the dropdown list as it wont fire automatically,
            in order to prevent infinite loops if triggered automatically */}
                  <input
                    // onClick={
                    //   this.state.dropdownList === "closed"
                    //     ? e => this.setState({ dropdownList: "open" })
                    //     : e => this.setState({ dropdownList: "closed" })
                    // }
                    ref={this.inputRef}
                    onFocus={e => this.renderDCs("updatelist")}
                    type="checkbox"
                    id="drop-down-trigger"
                  />
                  <ul className="custom-options">
                    <div className="select-actions">
                      <p>All: </p>
                      <div className="button">
                        <input
                          id="checkUS"
                          type="checkbox"
                          onChange={e => this.checkAllToggle(e, "USA")}
                        />
                        <label htmlFor="checkUS">US</label>
                        {/* <i className="material-icons">check_box</i> */}
                        {/* <i className="material-icons">check_box_outline_blank</i> */}
                      </div>
                      <div className="button">
                        <input
                          id="checkMEX"
                          type="checkbox"
                          onChange={e => this.checkAllToggle(e, "MEX")}
                        />
                        <label htmlFor="checkMEX">MEX</label>
                        {/* <i className="material-icons">check_box</i> */}
                        {/* <i className="material-icons">check_box_outline_blank</i> */}
                      </div>
                    </div>
                    <div
                      className="whse-list"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <div className="whse-list-side USA">
                        {this.renderDCs("renderlist", "USA")}
                      </div>
                      <div
                        className="separator"
                        style={{
                          width: "1px",
                          borderLeft: "1px solid rgba(150,150,150,.5)",
                          margin: "0 5px "
                        }}
                      />
                      <div className="whse-list-side MEX">
                        {this.renderDCs("renderlist", "MEX")}
                        <div>
                          <p className="storeSupply">Store Supply</p>
                          {this.renderDCs("renderlist", "STORESUP")}
                        </div>
                      </div>
                    </div>
                  </ul>
                  <i className="material-icons drop-down-arrow">
                    arrow_drop_down
                  </i>
                </div>
              </label>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

export default DcSelector;
